export default __webpack_public_path__ + "static/media/Banner2022_Doctor-min.83875402.png";